(function ($) {
    /*note : this should be specific code for a three column resizer with the layout here */
    /*for now think of as dragger for and left and right pane*/
    /* depending on fn.getMouseCoordinates */
    $.fn.dragPaneResizer = function(options) {  //perhaps just make 3 pane hor resizer ....

        var $dragger = this, //.drag(),
            $leftPane = options.leftPane,
            $rightPane = options.rightPane,

            $minLeftEl = options.minLeftEl, //element on left can't go past
            $maxRightEl = options.maxRightEl, //element on right can't go past

            $container = options.container,
            type = options.type, //right or left
           
            isDragging = false,

            dragStart = options.dragStart,
            dragEnd = options.dragEnd,
            dragMove = options.dragMove,
            draggingClass = options.draggingClass,


            draggerW = $dragger.width(),//todo: unknown until in dom

        //todo: a defaults -- CLEAN
            MIN_WIDTH = options.minWidth || 0, //('pixel') -- must give a min width -- otherwise funky after drag past end and back -- should be larger than the hoverpane

            maxWidth,

            originalH,
            lastX,
            leftBoundX,
            rightBoundX,

            fnApplyIframeFix = options.fnApplyIframeFix,   //here a fn that evaluates
            iframeOverlayClass = options.iframeOverlayClass, //USE THE OVERLAY IF PASS IN THE CLASS
            $iframeContainer,

            $iframeOverlay,
            $doc = $(document),
            
            leftPaneLftOffset,
            leftElLeftOffset,
            maxRightElLeftOffset,
            containerLeftOffset,
            containerWidth,
            maxRightElIsVisible,
            maxRightElWidth,
            minLeftElIsVisible,
            minLeftElLeftOffset,

            lastLeftPaneMarginRight,
            lastRightPaneWidth;

        $dragger.on('mousedown', onDraggerMouseDown);

        function onDraggerMouseDown(e) {

            e.preventDefault();
            e.stopPropagation(); //not allowing to prop a perf issue

            draggerW = $dragger.width(); //slop check in case calc'd when not yet in dom

            /*  don't do if the original target was not el : eg if click on collapser inside*/
            if (e.target !== $dragger[0]) return;

            dragStart && dragStart();

            isDragging = true;
            $dragger.addClass(draggingClass);
            lastX = $.fn.getMouseCoordinate(e).x;

            //if iframeFix create transparent overlay over the center container    -- could do alliframes ...
            //could repeat for each iframe
            //append show moves with iframe with out having to resize
            if (fnApplyIframeFix()) {
                var iframeContainer = options.$iframeContainer;
                $iframeContainer = typeof iframeContainer === 'function' ? iframeContainer() : iframeContainer; /* in case not create upon init */
                $iframeOverlay = $('<div></div>').attr('class', iframeOverlayClass).appendTo( $iframeContainer );
            }

            leftPaneLftOffset = $leftPane.offset().left;
            maxRightElLeftOffset = $maxRightEl.offset().left;
            containerLeftOffset = $container.offset().left;
            leftElLeftOffset = $minLeftEl.offset().left + MIN_WIDTH;
            containerWidth = $container.width();
            maxRightElIsVisible = $maxRightEl.is(':visible');
            maxRightElWidth = $maxRightEl.width();
            minLeftElIsVisible = $minLeftEl.is(':visible');
            minLeftElLeftOffset = $minLeftEl.offset().left;

            originalH = type === 'left' 
                ? leftPaneLftOffset 
                : leftPaneLftOffset + $leftPane.width(); 

            //left
             if (type === 'left') {

              if (!maxWidth) {
                rightBoundX = maxRightElIsVisible
                    ? maxRightElLeftOffset - draggerW
                    : containerLeftOffset + containerWidth - draggerW;
                } else {
                     rightBoundX = leftBoundX + maxWidth;
                }
            } else {
                 rightBoundX = !MIN_WIDTH
                    ? maxRightElLeftOffset + maxRightElWidth - draggerW
                    : maxRightElLeftOffset + maxRightElWidth - MIN_WIDTH;

                if (!maxWidth) {
                    leftBoundX = minLeftElIsVisible
                        ? minLeftElLeftOffset + (draggerW * 2)
                        : containerLeftOffset + (draggerW * 2);
                } else {
                    leftBoundX = rightBoundX - maxWidth;
                }

                lastLeftPaneMarginRight = parseFloat($leftPane.css('margin-right'));
                lastRightPaneWidth = parseFloat($rightPane.css('width'));
            }

             $doc.on('mousemove', onDocMouseMove).on('mouseup', docOnMouseup);
        }

        function onDocMouseMove(e) {
            
            e.preventDefault();
            e.stopPropagation();

            var x = e.pageX, 
                dx,
                resizeLeft = function() {  /* note: dragger moves with center pane */
                     //if x is within bound, change leftPane width and rightPane margin
                      if (x >= leftElLeftOffset && x <= rightBoundX) {

                        dx = x - originalH;
                        $leftPane.width(dx);
                        $rightPane.css('margin-left', dx);
                    }
                };

                //todo: also prevent from mouse going ahead


            if (isDragging) {

                if (type === 'left') {
                    _.debounce(resizeLeft, 100, true)();

                } else {
                    _.debounce(function() {
                         if (x >= leftBoundX && x <= rightBoundX) {
                            dx = lastX - x;
                            lastLeftPaneMarginRight += dx;
                            lastRightPaneWidth += dx;
                            lastX = x;
                            $leftPane.css('margin-right', lastLeftPaneMarginRight );
                            $rightPane.width(lastRightPaneWidth);
                        }
                    }, 100, true)();
                }

                dragMove(e);
            }
        }

        function docOnMouseup(e) {
            e.preventDefault();
            e.stopPropagation();
            $iframeOverlay && $iframeOverlay.length > 0 && $iframeOverlay.remove();
            $dragger.removeClass(draggingClass);
            isDragging = false;
            $doc.off('mousemove', onDocMouseMove).off('mouseup', docOnMouseup);
            dragEnd(e, type, (type === 'left' ? $leftPane.width() : $rightPane.width() ));
        }


        $dragger.on('destroy', function() {
            $dragger.off('mousedown', onDraggerMouseDown).off('destroy');
            $doc.off('mousemove', onDocMouseMove).off('mouseup', docOnMouseup);
        });


        return this;
    };

}(jQuery));


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/dragPane.js
 ** module id = 744
 ** module chunks = 0
 **/